// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper_vCQ0c","h1":"Contact_h1_Gvaop","section":"Contact_section_xPjAc","h2":"Contact_h2_XuaU8","a":"Contact_a_pRMx8"};